export const SET_AUTH="SET_AUTH"
export const SET_TOKEN="SET_TOKEN"
export const LOGOUT="LOGOUT"
